var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.914776 9.99984H3.04101V4.8448L0 2.58252V9.0974C0 9.59189 0.407941 9.99984 0.914776 9.99984Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3096 9.99984H12.4358C12.9426 9.99984 13.3506 9.59189 13.3506 9.08504V2.58252L10.3219 4.85716V9.99984H10.3096Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3096 0.913847V4.85739L13.3382 2.58274V1.37125C13.3382 0.246289 12.0526 -0.396545 11.1502 0.283376L10.3096 0.913847Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0293 4.84524V0.914062L6.66368 3.64611L10.2981 0.914062V4.8576L6.67604 7.57729L3.0293 4.84524Z",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.35887V2.57037L3.02865 4.84501V0.913833L2.17568 0.270998C1.28563 -0.39656 0 0.246274 0 1.35887Z",
    fill: "#C5221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.cfdc58389ef0eb70a8b031fbabbd2124.svg";
export { ForwardRef as ReactComponent };